import React, { useEffect, useState } from 'react'
import { order_history } from '../services/api';
import { errorMsg } from '../../../helper/helpers';
import QmModuleStyle from '../styles/qm.module.css';
import Button from '../../common/Button';

const UtilizedInvestments = ({ simObj, setSimObj, formatNum, setError, toggleSimulation,setToggleSimulation, isRequestLoading, isUtilizedActive, getMonth }) => {
    const [investmentOptions, setInvestmentOptions] = useState([]);
    const [isNoData, setIsNoData] = useState(false);
    const changeTabs = (e) => {
        // if (document.querySelector(".popup-container ui.stackable.two.column.grid") == null) {
        const tabs = document.getElementById(`panel_2`).querySelectorAll(`[role="tab"]`);
        tabs.forEach((tab) => {
            tab.setAttribute("tabindex", "-1");
        });

        const target = e.currentTarget;
        const parent = target.parentNode;
        let grandparent = parent.parentNode;
        if (window.$(e.target).closest('.ui.stackable.two.column')[0] != undefined) {
            grandparent = window.$(e.target).closest('.ui.stackable.two.column')[0];
        }

        // Remove all current selected tabs
        parent
            .querySelectorAll('[aria-selected="true"]')
            .forEach((t) => {
                t.setAttribute("aria-selected", false);
                t.style.color = "rgba(0,0,0,.6)";
                t.classList.remove(`${QmModuleStyle["active"]}`);
                t.classList.remove(`active`);
            });

        // Set this tab as selected
        target.setAttribute("aria-selected", true);
        target.style.color = "black";
        target.setAttribute("tabindex", "0");
        target.classList.add(`${QmModuleStyle["active"]}`);
        target.classList.add(`active`);

        // Hide all tab panels
        if (grandparent.classList.contains("stackable")) {
            grandparent
                .querySelectorAll('[role="tabpanel"]')
                .forEach((p) => {
                    p.setAttribute("hidden", true);
                    p.classList.remove(`active`);
                });
        }
        else {
            grandparent
                .querySelectorAll(`#${QmModuleStyle['panelList']}>div[role="tabpanel"]`)
                .forEach((p) => {
                    p.setAttribute("hidden", true);
                    p.classList.remove(`active`);
                });
        }
        // Show the selected panel
        let targetId = target.getAttribute("aria-controls");
        if (document.getElementById(targetId) != null) {
            document
                .getElementById(targetId)
                .removeAttribute("hidden");
            document
                .getElementById(targetId).classList.add(`active`)
        }
        setTimeout(() => {
            if (document.getElementById(targetId) != null) {
                document.getElementById(targetId).tabIndex = 0;
                document.getElementById(targetId).focus();
            }
        }, 1000);
        // }
        e.stopPropagation();
    }
    const handleTabs = () => {
        const tabs = document.getElementById(`panel_2`).querySelectorAll(`[role="tab"]`);
        const tabList = document.getElementById(`panel_2`).querySelector(`[role="tablist"]`);

        // Add a click event handler to each tab
        tabs.forEach((tab) => {
            tab.addEventListener("click", (e)=>{
                changeTabs(e);
                const tabs = document.querySelectorAll('#panel_2 [role="tab"]');
                let activeTab =  window.$(e.target).closest('.item.tab-item')[0];
                  tabs.forEach((tab) => {
                    tab.setAttribute("tabindex", "-1");
                  });
                  setTimeout(() => {
                    activeTab.setAttribute("tabindex", "0");
                    tabFocus = Array.from(tabs).indexOf(activeTab);
                  }, 0)
            });
            tab.addEventListener("keydown", (e) => {
                if (e.key == "Enter") {
                    changeTabs(e);
                }
            });
        });

        // Enable arrow navigation between tabs in the tab list
        let tabFocus = 0;

        if (tabList != null) {
            tabList.addEventListener("keydown", (e) => {
                // Move right
                const tabs = document.getElementById(`panel_2`).querySelectorAll(`[role="tab"]`);
                if ((e.shiftKey && e.key === 'Tab') || (e.key == "Tab")) {
                  let activeTab = document.getElementById(`panel_2`).querySelector(`[role="tab"].active`)
                  tabs.forEach((tab) => {
                    tab.setAttribute("tabindex", "-1");
                  });
                  setTimeout(() => {
                    activeTab.setAttribute("tabindex", "0");
                    tabFocus = Array.from(tabs).indexOf(activeTab);
                  }, 100)
                }
                if (e.key === "ArrowRight" || e.key === "ArrowLeft" || e.key === "ArrowUp" || e.key === "ArrowDown" || e.key === 'Home' || e.key === 'End') {
                    tabs[tabFocus].setAttribute("tabindex", -1);
                    if (e.key === "ArrowRight" || e.key === "ArrowDown") {
                        tabFocus++;
                        // If we're at the end, go to the start
                        if (tabFocus >= tabs.length) {
                            tabFocus = 0;
                        }
                        // Move left
                    } else if (e.key === "ArrowLeft" || e.key === "ArrowUp") {
                        tabFocus--;
                        // If we're at the start, move to the end
                        if (tabFocus < 0) {
                            tabFocus = tabs.length - 1;
                        }
                    }
                    else if (e.key === "Home") {
                        tabFocus = 0;
                    }
                    else if (e.key === "End") {
                        tabFocus = tabs.length - 1;
                    }
                    e.preventDefault();
                    tabs[tabFocus].setAttribute("tabindex", 0);
                    tabs[tabFocus].focus();
                }
            });
        }

        // tabs[0].click();
    }
    const orderHistory = () => {
        (simObj?.sessionid != undefined) && order_history(simObj?.sessionid, simObj?.id).then((response) => {
            if (response.status === 500 && response?.data?.hasOwnProperty("id") && response?.data?.hasOwnProperty("msg")) {
                setError(response?.data)
            }
            else{
            if (!(response.data.length > 0) || (response.data.length == undefined)) {
                setIsNoData(true);
            }
            setInvestmentOptions(response.data);
        }

        }).catch((error) => {
            // setError(errorMsg);
            setError({"id":"00000","msg":errorMsg})
            console.log(error);
        })
    }
    useEffect(() => {
       // (isUtilizedActive) && setToggleSimulation(false);
        (isUtilizedActive) && orderHistory();
    }, [isUtilizedActive])
    useEffect(() => {
        document.querySelector(`.utilized-investments`).querySelectorAll(`.item.tab-item`).forEach((element, index) => {
            if (index == 0) {
                element.setAttribute("tabindex", "0");
            }
        });
        //setInvestmentOptions(simObj?.laststate?.investmentOptions);
    }, [simObj?.laststate?.investmentOptions?.QMInvestmentOptions, investmentOptions]);
    // useEffect(()=>{
    //     if(Object.keys(investmentOptions).length > 0){
    //         setIsNoData(false);
    //     }
    //     else{
    //         setIsNoData(true);
    //     }
    // },[investmentOptions])

    useEffect(() => {
        handleTabs();
        if (document.querySelector("#panel_2 .tab-item")) {
            document.querySelector("#panel_2 .tab-item").click();
        }
    }, [investmentOptions])

    return (
        <div className={`ui stackable two column grid ${QmModuleStyle['ui']} ${QmModuleStyle['two']} ${QmModuleStyle['stackable']} ${QmModuleStyle['grid']} ${QmModuleStyle['column']} utilized-investments ${!(Object.keys(investmentOptions).length > 0 && isNoData) ? `${QmModuleStyle['loaderParent']}` : ""}`}>
            {(Object.keys(investmentOptions).length > 0) && (<>
                <div className={`six wide column ${QmModuleStyle['six']} ${QmModuleStyle['wide']} ${QmModuleStyle['column']}`} tabIndex={-1}>
                    <div className={`ui secondary segment ${QmModuleStyle['ui']} ${QmModuleStyle['secondary']} ${QmModuleStyle['segment']}`}>
                        <ul className={`ui divided list ${QmModuleStyle['ui']} ${QmModuleStyle['list']}`} role="tablist" aria-label="Reviews tabs">
                            {
                                investmentOptions?.sort((a, b) => (b.executionDate.split("-")[1] - a.executionDate.split("-")[1]))?.sort((a, b) => (b.executionDate.split("-")[0] - a.executionDate.split("-")[0]))?.map((inveItem, index) => (
                                    <li id={`_tab_${index + 1}`} key={index} className={`item tab-item ${index == 0 ? 'active' : ''} ${QmModuleStyle['item']} ${QmModuleStyle['tab-item']} ${index == 0 && `${QmModuleStyle['active']}`}`} data-tab={`tab-${index + 1}`} aria-selected={index == 0 ? true : false} role='tab' aria-controls={`_tab${index + 1}`} tabIndex={index == 0 ? 0 : -1}>
                                        <div className={`${QmModuleStyle['content']}`}>
                                            <p>{getMonth(inveItem.executionDate.split("-")[0])} {inveItem.executionDate.split("-")[1]}</p>
                                            <p>Made investment</p>
                                        </div>
                                    </li>
                                ))
                            }
                        </ul>
                    </div>
                </div>
                <div className={`ten wide column ${QmModuleStyle['ten']} ${QmModuleStyle['wide']} ${QmModuleStyle['column']}`}>
                    {
                        investmentOptions?.sort((a, b) => (b.executionDate.split("-")[1] - a.executionDate.split("-")[1]))?.sort((a, b) => (b.executionDate.split("-")[0] - a.executionDate.split("-")[0]))?.map((inveItem, index) => (
                            // inveItem.QMInvestmentOptions?.map((option, index) => {
                            <div className={`ui tab ${QmModuleStyle['review-container']} ${index == 0 ? 'active' : ''}`} key={index} data-tab={`tab-${index + 1}`} id={`_tab${index + 1}`} role='tabpanel' aria-labelledby={`_tab_${index + 1}`} tabIndex={0}>
                                <div className={`${QmModuleStyle['review-item']}`} >
                                    <ul>
                                        {
                                            inveItem?.QMInvestmentOptions?.map((item, index) => {
                                                return (
                                                    <div className={`ui compact message ${QmModuleStyle['ui']} ${QmModuleStyle['message']}`} key={`${index}_1`}>
                                                        <li>
                                                            <div>
                                                                <label role='checkbox' htmlFor="check1" aria-checked={item.selected ? true : false}>
                                                                    <input aria-disabled="true" disabled="disabled" checked={item.selected ? true : false} id={`check${index}`} tabIndex={-1} value={item?.cost} type="checkbox" role="presentation" aria-hidden="true" onChange={(e)=>{}} />
                                                                    {item?.option}
                                                                </label>
                                                                <span>
                                                                    {`${(simObj?.optionsToHide?.indexOf(item.oid.split("_")[0]) == -1) 
                                                                    ?  "$"+formatNum(item?.cost)
                                                                    : "Unknown"}`
                                                                    }
                                                                </span>
                                                                
                                                            </div>
                                                        </li>
                                                    </div>
                                                )
                                            })
                                        }
                                    </ul>
                                </div>
                            </div>
                            // })
                        ))
                    }
                </div>
            </>)
            }
            {
              (!isNoData && !(Object.keys(investmentOptions).length > 0)) &&  (
                    <div>
                        <div className="snippet" data-title="dot-pulse">
                            <div className={`${QmModuleStyle['stage']}`}>
                                <div className={`${QmModuleStyle['dot-pulse']}`}></div>
                            </div>
                        </div>
                    </div>
                )
            }
            {
                (isNoData && (Object.keys(investmentOptions).length == 0)) &&  <div className={`empty ${QmModuleStyle['empty']}`}>
                <div>
                  <div className={`ui info message ${QmModuleStyle['ui']} ${QmModuleStyle['info']} ${QmModuleStyle['message']}`}>
                    <div className="header">
                        You haven't utilized any investments.
                    </div>
                  </div>
                </div>
            </div>
            }
        </div>
    )
}

export default UtilizedInvestments
